module.exports = __webpack_public_path__ + "static/media/logo_scansource_select_colorido.5611134d.png";